import { render } from "./TerminateContract.vue?vue&type=template&id=0b47719a"
import script from "./TerminateContract.vue?vue&type=script&lang=js"
export * from "./TerminateContract.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__